<script setup lang="ts">
import MultiComboboxInput from '@/components/selectBox/combobox/MultiComboboxInput.vue';
import { Selectable } from '@/components/selectBox/selectBox';
import { useCaseloadsSearch } from '@/hooks/search/useCaseloadsSearch';

const { caseloadOptions, isLoading, onQueryChange } = useCaseloadsSearch();

defineProps<{
  modelValue: Selectable<number>[];
}>();

defineEmits(['update:modelValue']);
</script>

<template>
  <MultiComboboxInput
    :options="caseloadOptions"
    :onFilter="onQueryChange"
    :isLoading="isLoading"
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    @open="() => onQueryChange('')"
  />
</template>
